// @flow

import React from 'react';
import { TileSelect, Tile } from '../../../tileSelect';
import { SmallColor } from '../../../configColor';
import type { PackageColor } from '../../../../../../types/pdb';
import withPdbColors from '../atoms/withPdbColors';
import {
  ColorName,
  ColorPrice,
} from './atoms';
import { priceFormat } from '../../../../../../helpers';

type StateProps = {
  colors: Array<PackageColor>,
  activeColor: ?PackageColor,
  activeColorId: ?number,
};

type DispatchProps = {
  setColor: Function,
};

type Props = StateProps & DispatchProps;

const createTitle = (color: PackageColor) => {
  if (color.addColors && color.addColors.name !== '') {
    return `${color.name} / ${color.addColors.name}`;
  }
  return `${color.name}`;
};

const SmallColors = ({
  colors, activeColor, activeColorId, setColor,
}: Props) => (
  <>
    <TileSelect>
      {colors.map(({
        id, name, price, hexcode, addColors,
      }) => (
        <Tile
          key={id}
          active={activeColorId === id}
          onClick={() => setColor(id)}
          blocksPerRow={0}
          blockCount={colors.length}
          boxed={false}
        >
          <SmallColor
            color={`#${hexcode}`}
            title={name}
            price={price}
            active={activeColorId === id}
            twoToneColor={addColors && `#${addColors.hexcode}`}
            twoToneTitle={addColors && addColors.name}
          />
        </Tile>
      ))}
    </TileSelect>
    {activeColor && (
      <>
        <ColorName>{createTitle(activeColor)}</ColorName>
        <ColorPrice>
          {priceFormat(activeColor.price, {
            currency: true,
          })}
        </ColorPrice>
      </>
    )}
  </>
);

export default withPdbColors(SmallColors);
